import { keyframes } from 'styled-components';

export const TRANSLATE_VALUES = {
  VISIBLE: '0',
  HIDDEN_LEFT: '-105%',
  HIDDEN_RIGHT: '105%',
  SLIDE_START_LEFT: '-100%',
  SLIDE_START_RIGHT: '100%'
};

export const SLIDE_IN_FROM_LEFT = keyframes`
  from {
    translate: ${TRANSLATE_VALUES.SLIDE_START_LEFT};
  }
  to {
    translate: ${TRANSLATE_VALUES.VISIBLE};
  }
`;

export const SLIDE_IN_FROM_RIGHT = keyframes`
  from {
    translate: ${TRANSLATE_VALUES.SLIDE_START_RIGHT};
  }
  to {
    translate: ${TRANSLATE_VALUES.VISIBLE};
  }
`;

export const SLIDE_OUT_TO_LEFT = keyframes`
  from {
    translate: ${TRANSLATE_VALUES.VISIBLE};
  }
  to {
    translate: ${TRANSLATE_VALUES.HIDDEN_LEFT};
  }
`;

export const SLIDE_OUT_TO_RIGHT = keyframes`
  from {
    translate: ${TRANSLATE_VALUES.VISIBLE};
  }
  to {
    translate: ${TRANSLATE_VALUES.HIDDEN_RIGHT};
  }
`;
